import { Media, SectionWrapper, Slider } from '@portfolio/components'
import { SectionPeopleCard, SectionPeopleProps } from '@portfolio/models'
import { styled } from '@portfolio/styles'

const SectionPeopleContainer = styled(SectionWrapper, {
  '@lg': {
    paddingInline: 30,
  },
})

const SectionPeopleTitle = styled('h2', {
  marginBlockEnd: 96,
  projectFont: 'heading02',
  color: '$white',
  textAlign: 'center',
  marginInline: 'auto',

  '@lg': {
    maxWidth: 500,
  },
})

const PeopleGrid = styled('div', {
  display: 'grid',
  gap: 20,
  paddingBlock: 24,

  '@lg': {
    gridTemplateColumns: 'repeat(3, auto)',
    justifyContent: 'center',
    gridAutoFlow: 'column',
  },
})

const Card = styled('div', {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 20,
})

const SectionPeopleCardContainer = styled(Card, {
  display: 'flex',
  flexDirection: 'column',
  gap: '30px 0',
  padding: 20,
  backgroundColor: '#212121',
  justifyContent: 'start',

  '@lg': {
    maxWidth: 440,
    minHeight: 440,
  },
})

const CardContent = styled('div', {
  projectFont: 'body03',
  color: '$white',
  alignSelf: 'flex-end',
})

const CardMedia = styled('div', {
  overflow: 'hidden',
  borderRadius: 8,
})

const CardDetailsName = styled('span', {
  display: 'block',
  projectFont: 'body03',
  color: '$gray300',
  alignSelf: 'flex-end',
})

const CardDetailsPosition = styled('span', {
  display: 'block',
  projectFont: 'body03',
  color: '$gray300',
  alignSelf: 'flex-end',
})

const DesktopVisibilityContainer = styled('div', {
  display: 'none',

  '@lg': {
    display: 'block',
  },
})
const MobileVisibilityContainer = styled('div', {
  display: 'block',

  '@lg': {
    display: 'none',
  },
})

const PeopleCard = ({
  card,
  priority,
}: {
  card: SectionPeopleCard
  priority?: boolean
}) => {
  return (
    <SectionPeopleCardContainer>
      {card.media && (
        <CardMedia>
          <Media
            {...card.media}
            priority={priority}
            objectFit="contain"
            sizes="(min-width: 1024px) 33vw, 100vw"
          />
        </CardMedia>
      )}

      <div>
        {card.content && <CardContent>{card.content}</CardContent>}
        {card?.name && <CardDetailsName>{card.name}</CardDetailsName>}
        {card?.position && (
          <CardDetailsPosition>{card.position}</CardDetailsPosition>
        )}
      </div>
    </SectionPeopleCardContainer>
  )
}

export function SectionPeople({
  title,
  cards,
  priority,
  spacing,
  topBorder,
}: SectionPeopleProps) {
  return (
    <SectionPeopleContainer type={spacing || 'DEFAULT'} topBorder={topBorder}>
      {title && <SectionPeopleTitle>{title}</SectionPeopleTitle>}
      <DesktopVisibilityContainer>
        <PeopleGrid>
          {cards?.map((card) => {
            return (
              <PeopleCard key={card._key} card={card} priority={priority} />
            )
          })}
        </PeopleGrid>
      </DesktopVisibilityContainer>
      <MobileVisibilityContainer>
        {!!cards?.length && (
          <Slider isFullWidth>
            {cards.map((card) => {
              return (
                <PeopleCard key={card._key} card={card} priority={priority} />
              )
            })}
          </Slider>
        )}
      </MobileVisibilityContainer>
    </SectionPeopleContainer>
  )
}
